//src/command/utils/sembols.js

import { Rectangle, PolyLine, Line, Text, voltageDrop } from "./utils";
const layers = {
  0: { name: '0', frozen: false, visible: true, colorIndex: 7, color: 16777215 },
  kirmizi: { name: '18', frozen: false, visible: true, colorIndex: 1, color: 16711680 },
  yesil: { name: 'test', frozen: false, visible: true, colorIndex: 1, color: 65280 },
  mavi: { name: 'test', frozen: false, visible: true, colorIndex: 1, color: 255 },
  sari: { name: 'test', frozen: false, visible: true, colorIndex: 1, color: 16776960 },
  magenta: { name: 'test', frozen: false, visible: true, colorIndex: 1, color: 16711935 },
  cyan: { name: 'test', frozen: false, visible: true, colorIndex: 1, color: 65535 },
  gray: { name: 'test', frozen: false, visible: true, colorIndex: 8, color: 12632256 },
  AKSYAZI: { name: 'AKSYAZI', frozen: false, visible: true, colorIndex: 9, color: 12632256 }
};
const kirmizi = layers.kirmizi
const mavi = layers.mavi
const yesil = layers.yesil
const gray = layers.gray
const op_kirmizi = {
  color: kirmizi.color,
  colorIndex: kirmizi.colorIndex,
  layer: kirmizi.name,
  // lineType:layer.lineType,
  shape: true,
  hasContinuousLinetypePattern: false
}

const op_mavi = {
  color: mavi.color,
  colorIndex: mavi.colorIndex,
  layer: mavi.name,
  // lineType:layer.lineType,
  shape: true,
  hasContinuousLinetypePattern: false
}

const op_yesil = {
  color: yesil.color,
  colorIndex: yesil.colorIndex,
  layer: yesil.name,
  // lineType:layer.lineType,
  shape: true,
  hasContinuousLinetypePattern: false
}
const op_gray = {
  color: gray.color,
  colorIndex: gray.colorIndex,
  layer: gray.name,
  // lineType:layer.lineType,
  shape: true,
  hasContinuousLinetypePattern: false
}
const Scl = 0.55

/* let gerDusData={
  floorName:"Çatı Katı",
  startName:"Şebeke",
  startNode:"BOX",
  lengths:{enOda_KabBac:3,kabBac_Daire:4,kabBac:5},
  circuits:[
  
  {length:20,voltage:380,power:100000,crosSecArea:10,phase:3,name:"ADP",cable:"4x10mm² NYY"},
  {length:15,voltage:380,power:10000,crosSecArea:4,phase:3,name:"ZKT",cable:"4x4mm² NYM"},
  {length:20,voltage:220,power:2500,crosSecArea:2.5,phase:1,name:"ÇM",cable:"3x2.5mm² NYA"},

]}
 */
export const createGerilimDusum = (X, Y, W, H, gerDusData) => {
  if (!gerDusData || !gerDusData.lengths) {
     return { result: [], width: W || 125, height: H || 550 };
  }
  let result = []
 
  let option = op_gray
  let enOda_KabBac = gerDusData.lengths.enOda_KabBac
  let kabBac_Daire = gerDusData.lengths.kabBac_Daire
  let kabBac = gerDusData.lengths.kabBac
  let totalLenght = enOda_KabBac + kabBac_Daire + kabBac

  let hY = H - 5 * Scl
  // gerDusHeight içerik tamamlandıktan sonra hesaplanır; geçici üst-y referansı:
  const topY = hY + 75 * Scl;
  let textHeight = 50 * Scl
  let text = { text: "GERİLİM DÜŞÜMÜ HESABI".toString(), x: X + 665 * Scl, y: hY + 20 * Scl, textHeight: textHeight }
  text.handle = generateStableId(text)
  result.push(Text(text.x, text.y, text, 0, option))
  // Rectangle'ı sona bırak (gerçek bottom Y bilindikten sonra ekle)
  hY -= 20 * Scl
  result.push(Line(X, hY, 2100 * Scl, hY, option))
  hY -= 70 * Scl

  let floorName = gerDusData.floorName

  text = { text: floorName, x: X + 50 * Scl, y: hY, textHeight: textHeight }
  hY -= 60 * Scl
  text.handle = generateStableId(text)
  result.push(Text(text.x, text.y, text, 0, option))
  /*
    textHeight=25*Scl
    hY-=80*Scl
    text={text:`Yatay Mesafeler>> Enerji Odası-Kablo Bacası:${enOda_KabBac}m     Kablo Bacası-Daire Arası ${kabBac_Daire}m  Toplam Yatay Mesafe:${enOda_KabBac+kabBac_Daire}m `,x:X+ 50*Scl   ,y:hY,textHeight:textHeight}  
    text.handle=generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))  
    hY-=80*Scl
    
    text={text:`Dikey Mesafeler>> Kablo Bacası:${kabBac}m     Yatay+Dikey Toplam Mesafe:${totalLenght}m `,x:X+ 50*Scl   ,y:hY,textHeight:textHeight}  
    text.handle=generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))  
  */
  hY -= 150 * Scl
  let circuits = gerDusData.circuits
  let X2 = X + 100 * Scl


  text = { text: gerDusData.startName, x: X + 50 * Scl, y: hY + 50 * Scl, textHeight: textHeight }
  text.handle = generateStableId(text)
  result.push(Text(text.x, text.y, text, 0, option))

  textHeight = 18 * Scl
  let totalVoltageDrop = 0
  let voltageDrops = []
  circuits.forEach((circuit, c) => {
    result.push(Line(X + X2 + 35 * Scl, hY + 20 * Scl, X + X2 + 575 * Scl, hY + 20 * Scl, option))
    text = { text: ` ${circuit.cable} ${circuit.length}m`, x: X2 + 150 * Scl, y: hY + 27 * Scl, textHeight: textHeight }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))

    text = { text: ` ${circuit.name} `, x: X2 + 550 * Scl, y: hY + 27 * Scl, textHeight: textHeight }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))

    let power = circuit.power
    if (typeof circuit.power === "number") {
      if (circuit.power > 9999) {
        power = (circuit.power / 1000).toFixed(0) + "kW";
      } else {
        power = circuit.power.toFixed(0) + "W";
      }
    } else {
      console.warn("❗ circuit.power undefined veya sayı değil:", circuit.power);
      power = "-";
    }
    text = { text: power, x: X2 + 550 * Scl, y: hY - 50 * Scl, textHeight: textHeight }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))

    let gerDus = voltageDrop(circuit.voltage, circuit.power, circuit.phase, circuit.length, circuit.crosSecArea, "Cu")

    text = { text: `%E${c + 1}=${gerDus.coefficient}x(${circuit.length}x ${circuit.power})/${circuit.crosSecArea}`, x: X2 + 150 * Scl, y: hY - 40 * Scl, textHeight: textHeight }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))

    text = { text: `%E${c + 1}=${gerDus.voltageDropPercent} %`, x: X2 + 150 * Scl, y: hY - 80 * Scl, textHeight: textHeight }
    text.handle = generateStableId(text)
    result.push(Text(text.x, text.y, text, 0, option))
    totalVoltageDrop += parseFloat(gerDus.voltageDropPercent)
    voltageDrops.push(gerDus.voltageDropPercent)
    X2 += 565 * Scl
    let vertices = [
      { x: X2, y: hY, z: 0 },
      { x: X2 + 50 * Scl, y: hY, z: 0 },
      { x: X2 + 25 * Scl, y: hY - 25 * Scl, z: 0 },
    ]
    result.push(PolyLine(X, hY - 20 * Scl, vertices, option))
  })

  text = {
    text: `Toplam Yüzde Gerilim Düşümü= %E=${voltageDrops
      .map((val, v) => `%E${(v + 1)}${v < voltageDrops.length - 1 ? "+" : ""}`)
      .join("")}`, x: X + 50 * Scl, y: hY - 130 * Scl, textHeight: textHeight
  }
  text.handle = generateStableId(text)
  result.push(Text(text.x, text.y, text, 0, option))

  text = {
    text: `Toplam Yüzde Gerilim Düşümü= %E=${voltageDrops
      .map((val, v) => `${val}${v < voltageDrops.length - 1 ? "+" : ""} `)
      .join("")}=%${totalVoltageDrop.toFixed(3)}`, x: X + 50 * Scl, y: hY - 170 * Scl, textHeight: textHeight
  }

  text.handle = generateStableId(text)
  result.push(Text(text.x, text.y, text, 0, option))

  // İçerik tamamlandı — gerçek bottom Y'yi hesapla ve rect'i şimdi ekle
  // Son text hY - 170'te; textHeight=18 olduğundan baseline'ın altına biraz padding ekleyelim
  const bottomY = hY - 170 * Scl - 30 * Scl;   // text descender + alt padding
  const gerDusHeight = topY - bottomY;
  // Rect'i en üste ekleyelim ki içerik üstünde çizilsin (Three.js sıra önemi düşük ama
  // semantik olarak çerçeve genelde başta yazılır)
  result.unshift(Rectangle(X, topY, 2100 * Scl, -gerDusHeight, option))

  return { result: result, width: 2100 * Scl, height: gerDusHeight };
};



function generateStableId(element) {
  let faktor = "0"
  if (element.handFak) { faktor = element.handFak }
  return `text-${element.text}-${element.x}-${element.y}-${element.textHeight}-${faktor}`;
}











